import { Routes, RouterModule } from '@angular/router';
import { CheckSessionGuard } from '../../shared/services/guards/session.guards';
import { NewBookingComponent } from './new-booking-report.component';
import { CreateComponent } from './create/create.component';
import { ListComponent } from './list/list.component';

const appRoutes: Routes = [
  {
    path: 'new-booking',
    component: NewBookingComponent,
    children: [
      {
        path: 'list',
        component: ListComponent,
        canActivate: [ CheckSessionGuard ]
      },
      {
        path: 'create',
        component: CreateComponent,
        canActivate: [ CheckSessionGuard ]
      },
      {
        path: 'modify/:id',
        component: CreateComponent,
        canActivate: [ CheckSessionGuard ]
      },
      {
        path: '',
        redirectTo: '/new-booking/list',
        pathMatch: 'full'
    },
    ]
  }
];

export const APP_ROUTES_MAIN = RouterModule.forChild(appRoutes);
